import React from 'react';

export const QuotePlaceholderTable = (props: any) => {
  const { rowNum = 4, colNum = 5, firstColNarrow } = props;

  const colToWiden = React.useMemo(() => {
    return firstColNarrow ? 1 : 0;
  }, [firstColNarrow]);

  const colWidth = React.useCallback(
    (colIdx: any) => {
      if (colIdx == 0 && firstColNarrow) {
        return "20px";
      } else if (colIdx == colToWiden) {
        return "220px";
      }
      return "";
    },
    [firstColNarrow, colToWiden]
  );

  return (
    <table className="lightershadow quote-datatable table table-bordered table-hover order-column dataTable">
      <thead>
        <tr>
          {Array(+colNum)
            .fill(1)
            .map((a, idx) => (
              <td
                key={`colh_${idx}`}
                width={idx == 0 && firstColNarrow ? "20px" : ""}
              >
                <div
                  style={{ width: idx == 0 && firstColNarrow ? "20px" : "" }}
                  className="placeholder-box"
                ></div>
              </td>
            ))}
        </tr>
      </thead>
      <tbody>
        {Array(+rowNum)
          .fill(1)
          .map((a, idx) => (
            <tr
              key={`colb_${idx}`}
              role="row"
              className={idx % 2 ? "even" : "odd"}
            >
              {Array(+colNum)
                .fill(1)
                .map((a, colIdx) => (
                  <td key={`row_${colIdx}`}>
                    <div
                      style={{ width: colWidth(colIdx) }}
                      className="placeholder-box"
                    ></div>
                  </td>
                ))}
            </tr>
          ))}
      </tbody>
    </table>
  );
};
